import { Link } from "react-router-dom";

const SRC = "/mahogany-logo-v2.png";

const HEIGHTS = {
  sm: "h-14 sm:h-16",
  md: "h-20 sm:h-24",
  lg: "h-28 sm:h-36",
};

export const Logo = ({ size = "md", className = "" }) => (
  <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-link">
    <img
      src={SRC}
      alt="The Mahogany Room — A Literary Society for Black Women, By Jabrena"
      className={`${HEIGHTS[size] || HEIGHTS.md} w-auto object-contain`}
      draggable="false"
    />
  </Link>
);

export default Logo;
